import Vue from 'vue';
import mitt from 'mitt'
window.emitter = mitt()
window.Vue = Vue

import createPersistedState from 'vuex-persistedstate'
export default ({ store }) => {
    createPersistedState({
        key: 'sportbook',
        paths: ['auth', 'settings', 'betslip.selections', 'betslip.stakeDefault', 'betslip.stakeSingle', 'betslip.stakeCombi', 'betslip.stakeSystem', 'betslip.stakes', 'betslip.betType', 'betslip.updatedAt', 'betslip.lastUsedStake', 'cashoutHistory', 'notifications']
    })(store)
}

const VScrollLock = () => import('v-scroll-lock')
Vue.use(VScrollLock, {
    bodyScrollOptions: {
        allowTouchMove: el => {
            while (el && el !== document.body) {
              if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                console.log('allowTouchMove', el.getAttribute('body-scroll-lock-ignore'));

                return true;
              }
        
              el = el.parentElement;
            }
          },
    },
})

import * as VueDeepSet from 'vue-deepset'
Vue.use(VueDeepSet)

const vueDialog = () =>  import('@dmuy/dialog/vue-dialog')
Vue.use(vueDialog)

import { Notyf } from "notyf";
const notyf = new Notyf({ duration: 7000, position: {x:'center',y:'bottom'}, types: [
  {
    type: 'info',
    background: 'black',
    icon: false
  }
]});
Object.defineProperty(Vue.prototype, "$notyf", { value: notyf });

var Tick = require('tick-tock');
window.tock = new Tick();
window.Vue = Vue;

const VueTimers = () => import('vue-timers')
Vue.use(VueTimers)

const VueAspectRatio = () => import("vue-aspect-ratio")
Vue.component("vue-aspect-ratio", VueAspectRatio)

const VueSnap = () =>  import('vue-snap')
import 'vue-snap/dist/vue-snap.css'
Vue.use(VueSnap)

const Vuelidate = () => import('vuelidate')
Vue.use(Vuelidate)

const vueAwesomeCountdown = () => import('vue-awesome-countdown')
Vue.use(vueAwesomeCountdown, 'vac')


const Skeleton = () => import('vue-loading-skeleton')
Vue.use(Skeleton)

const VShowSlide = () => import('v-show-slide')
Vue.use(VShowSlide)

const LoadScript = () => import('vue-plugin-load-script')
Vue.use(LoadScript);

import * as VueSpinnersCss from "vue-spinners-css";
Vue.use(VueSpinnersCss)

import { Carousel, Slide } from 'vue-carousel'
Vue.component('Carousel', Carousel)
Vue.component('Slide', Slide)

const VTooltip = () =>  import('v-tooltip')
Vue.use(VTooltip)

const vClickOutside = () =>  import('v-click-outside')
Vue.use(vClickOutside)